import React from 'react';
import { makeStyles, TextField, FormControl } from '@material-ui/core';
import { t } from 'src/shared/literals';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '200px',
    margin: theme.spacing(1)
  },
  formControlFullWidth: {
    width: '99%',
    margin: theme.spacing(1)
  }
}));

const FormTextArea = ({ field, handleChangeField }) => {
  const classes = useStyles();

  const { name, value, readonly, errorMessage, fullWidth } = field;

  return (
    <FormControl
      className={
        typeof fullWidth !== 'undefined' && fullWidth
          ? classes.formControlFullWidth
          : classes.formControl
      }
      key={name}
    >
      <TextField
        error={Boolean(errorMessage)}
        helperText={t(errorMessage)}
        label={t(name.toString())}
        margin="normal"
        name={name}
        multiline
        InputProps={{
          readOnly: readonly
        }}
        rowsMax={10}
        onBlur={() => {}}
        onChange={handleChangeField}
        type="text"
        value={value}
        variant="outlined"
        className={classes.textField}
      />
    </FormControl>
  );
};

export default FormTextArea;
